/* Type Source: https://github.com/fartherfinance/database/blob/master/src/main/scala/com/farther/database/constants/person.scala */
export const employmentStatusOptions = [
    "Employed",
    "Unemployed",
    "Retired",
];
//# sourceMappingURL=employment.js.map